<template>
    <Modal v-if="!type || !loginModal.type || loginModal.type === type" modalType="loginModal" :removePadding="true" :narrow="false" :open="loginModal.show" :show-close-icon="true" @close="dismissModal" :is-card="true" :close-has-background="true">
        <div class="login-modal__container">
            <div class="login-modal__form">
                <ul v-if="hasErrors" class="validation-error__ul ul__no-bullet">
                    <li v-for="error in errors" :key="error" class="validation-error__li validation-error--danger">{{ error }}</li>
                </ul>
                <div v-if="statusMessage" class="validation-error__ul ul__no-bullet">
                    <li class="validation-error__li validation-error--success">
                        {{ statusMessage }}
                    </li>
                </div>
                <div v-if="showRegisterForm" class="login-modal__register">
                    <div class="login-modal__form-item">
                        <h1 class="login-modal__form-h1">Create an account</h1>
                        <p class="login-modal__form-subheading">Save the valuation to your account to resume at a later date.</p>
                    </div>
                    <div class="login-modal__form-item">
                        <create-password :showEmail="true" :registration="valuation.reg_no" :mileage="valuation.mileage" :locationId="Number(customerData.locationId)" />
                    </div>
                    <div class="login-modal__form-item">
                        <a href="" @click.prevent="returnToLogin" class="login-modal__form-forgot">Return to login</a>
                    </div>
                </div>

                <div v-else-if="showForgotPassword === false">
                    <div class="login-modal__form-item">
                        <h1 class="login-modal__form-h1">Login to your account</h1>
                        <p class="login-modal__form-subheading">Save the valuation to your account to resume at a later date.</p>
                    </div>
                    <div class="login-modal__form-item">
                        <email :readonly="!loginOnly" @input="form.email = $event" />
                    </div>
                    <div class="login-modal__form-item">
                        <div class="login-modal__password-container">
                            <input v-model="form.password" class="form-element__input" :type="passwordFieldType" name="password" id="password" placeholder="Password*">
                            <span class="login-modal__toggle-password" @click="togglePasswordVisibility">
                                <img :src="eyeIcon" alt="Toggle Password" class="login-modal__eye-icon" id="eye-icon">
                            </span>
                        </div>
                    </div>
                    <div class="login-modal__form-item">
                        <a type="button" @keypress.enter="login" @click="login" class="btn btn--primary btn--full-width">Sign In</a>
                    </div>
                    <div class="login-modal__form-item">
                        <a href="" @click.prevent="toggleForgotPassword" class="login-modal__form-forgot">Forgot Password?</a>
                    </div>
                </div>
                <div v-else>
                    <div class="login-modal__form-item">
                        <h1 class="login-modal__form-h1">Reset Password</h1>
                    </div>
                    <div class="login-modal__form-item">
                        <input v-model="form.email" type="text" data-validate="input"
                            data-validate-message="Please enter your email" name="email"
                            autocomplete="off" class="form-element__input" placeholder="Email address*">
                    </div>
                    <div class="login-modal__form-item">
                        <a @click="resetPassword" class="btn btn--primary btn--full-width">SEND PASSWORD REST LINK</a>
                    </div>
                    <div class="login-modal__form-item">
                        <a href="" @click.prevent="returnToLogin" class="login-modal__form-forgot">Return to login</a>
                    </div>
                </div>
                <div v-if="!showRegisterForm && !loginOnly" class="login-modal__form-create">
                    <h2 class="login-modal__form-h2">Don't have an account?</h2>
                    <div class="login-modal__form-item">
                        <button @click="register" class="btn btn--primary-inverted btn--full-width">CREATE AN ACCOUNT</button>
                    </div>
                </div>
            </div>
            <div class="login-modal__bg">
                <img src="/images/my-account/my-account-icon.svg" alt="" class="login-modal__my-account-icon" />
            </div>
        </div>
    </Modal>
</template>

<script>
import Modal from "../../../core/components/Modal.vue";
import CreatePassword from "../../../core/components/Forms/CreatePassword.vue";
import Email from "../../../core/components/Forms/Email.vue";
import { mapState, mapGetters, mapMutations, mapActions } from 'vuex';

export default {
    components: {
        Modal,
        CreatePassword,
        Email
    },

    props: {
        type: String
    },

    data() {
        return {
            form:{
                email:null,
                password:null,
            },
            showPassword: false,
            showForgotPassword: false,
            showRegisterForm: false
        };
    },

    computed: {
        ...mapState('ValuationTool', ['valuation']),
        ...mapGetters('CustomerData', ['customerData']),
        ...mapState("Auth", [
            'loginModal',
            'errors',
            'statusMessage',
            'loginOnly'
        ]),
        hasErrors() {
            return this. errors && this.errors.length > 0;
        },
        passwordFieldType() {
            return this.showPassword ? 'text' : 'password';
        },
        eyeIcon() {
            return this.showPassword ? '/images/my-account/eye-closed.svg' : '/images/my-account/eye-open.svg';
        }
    },

    methods: {
        ...mapMutations("Auth", ["setErrors", "setStatusMessage"]),
        ...mapActions("ValuationExtended", [ "storeValuation", "clearSession"]),
        ...mapActions("ValuationTool", [ "newValuation"]),

        togglePasswordVisibility() {
            this.showPassword = !this.showPassword;
        },
        toggleForgotPassword(){
            this.showForgotPassword = true;
            this.resetMessages();
        },
        returnToLogin(){
            this.showRegisterForm = false;
            this.showForgotPassword = false;
            this.resetMessages();
        },
        login(){
            console.log(this.form)
            this.$store.dispatch('Auth/login', { email: this.form.email, password: this.form.password })
        },
        resetPassword() {
            this.$store.dispatch('Auth/resetPassword', { email: this.form.email }).then(this.showForgotPassword = false)
        },
        dismissModal() {
            this.resetMessages();
            // this.clearSession(['valuation_data', 'extended_valuation_data', 'valuation_log_id']);
            this.$store.commit("Auth/setShowLoginModal", {
                show:false,
                type:'',
            });
        },
        register() {
            this.showRegisterForm = true;
            this.resetMessages();
        },
        resetMessages(){
            this.setStatusMessage();
            this.setErrors();
        },
    },

    beforeDestroy() {
        this.resetMessages();
    },
};
</script>

<style lang="scss">
    @import "../../../../sass/used/search-results";
    @import "../../../../sass/used/search-results/login-modal";
</style>
